__webpack_require__.p = "https://bmidxbindiaplpreprod.netlify.app/";